import template from './loader.html';
import controller from './loader.controller';

let loaderComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default loaderComponent;



// WEBPACK FOOTER //
// ./client/app/common/loader/loader.component.js